import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import type {
  CreateLinkedOpenSolarProjectInput,
  CreateLinkedOpenSolarProjectMutation,
} from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const CreateLinkedOpenSolarProjectMutation = graphql(`
  mutation CreateLinkedOpenSolarProject(
    $input: CreateLinkedOpenSolarProjectInput!
  ) {
    createLinkedOpenSolarProject(input: $input) {
      __typename
      ... on CreateLinkedProjectError {
        code
        message
      }
    }
  }
`);

const useCreateLinkedEasyPVProject = (
  options?: UseMutationOptions<
    CreateLinkedOpenSolarProjectMutation,
    unknown,
    CreateLinkedOpenSolarProjectInput
  >
) => {
  return useMutation({
    mutationFn: (input: CreateLinkedOpenSolarProjectInput) => {
      return gqlClient.request(CreateLinkedOpenSolarProjectMutation, {
        input,
      });
    },
    ...options,
  });
};

export default useCreateLinkedEasyPVProject;
